(function () {
  var drawer = document.querySelector("[data-cart-drawer]");
  if (!drawer) return;

  var backdrop = drawer.querySelector("[data-cart-drawer-backdrop]");
  var panel = drawer.querySelector("[data-cart-drawer-panel]");
  var itemsEl = drawer.querySelector("[data-cart-drawer-items]");
  var subtotalEl = drawer.querySelector("[data-cart-drawer-subtotal]");
  var upsellsEl = drawer.querySelector("[data-cart-drawer-upsells]");
  var upsellsList = drawer.querySelector("[data-cart-drawer-upsells-list]");
  var freeShippingEl = drawer.querySelector("[data-cart-drawer-free-shipping]");
  var checkoutEl = drawer.querySelector("[data-cart-drawer-checkout]");
  var wasEl = drawer.querySelector("[data-cart-drawer-was]");
  var saveBadgeEl = drawer.querySelector("[data-cart-drawer-save]");
  var countdownEl = drawer.querySelector("[data-cart-drawer-countdown]");
  var protectionEl = drawer.querySelector("[data-cart-protection]");
  var alarmUpgradeEl = drawer.querySelector("[data-cart-alarm-upgrade]");

  var shopUrl = (drawer.getAttribute("data-shop-url") || "").replace(/\/$/, "");
  var currentProductId = parseInt(drawer.getAttribute("data-current-product-id") || "0", 10);
  var alarmProductTitle = drawer.getAttribute("data-alarm-product-title") || "";
  var moneyFmt = drawer.getAttribute("data-money-format") || "{{amount}}";
  var curCode = drawer.getAttribute("data-currency") || "";
  var emptyText = drawer.getAttribute("data-empty-text") || "Your cart is empty.";
  var freeShippingThreshold = parseInt(drawer.getAttribute("data-free-shipping-threshold") || "0", 10);
  var qtyUpsellText = drawer.getAttribute("data-qty-upsell-text") || "";
  var giftThreshold = parseInt(drawer.getAttribute("data-gift-threshold") || "0", 10);
  var shippingLabel = drawer.getAttribute("data-shipping-label") || "Free shipping";
  var giftLabel = drawer.getAttribute("data-gift-label") || "Free gift";
  var giftVariantId = parseInt(drawer.getAttribute("data-gift-variant-id") || "0", 10);
  var giftSyncing = false;
  var roadSignsSyncing = false;

  // [{qty, title, total, compare, save}] — pack pricing keyed by total units in
  // the cart, so the pack is recomputed when the shopper changes the quantity.
  var bundleTiers = [];
  try {
    bundleTiers = JSON.parse(drawer.getAttribute("data-bundle-tiers") || "[]");
  } catch (e) {}
  bundleTiers.sort(function (a, b) { return a.qty - b.qty; });

  var upsellProducts = [];
  var upsellCatalog = [];
  var renderedUpsellProducts = [];
  var upsellIndex = 0;
  var miniRcUpsellStep = null;
  var upsellAdding = false;
  try {
    var upsellScript = document.getElementById("UpsellProductsJson");
    if (upsellScript && upsellScript.textContent) {
      upsellProducts = JSON.parse(upsellScript.textContent);
      upsellCatalog = upsellProducts.slice();
    }
  } catch (e) {}

  var lastFocusedEl = null;
  var countdownStarted = false;
  var focusableSelector = 'a[href], button:not([disabled]), input:not([disabled]), textarea:not([disabled]), select:not([disabled]), [tabindex]:not([tabindex="-1"])';

  function initCountdown() {
    if (!countdownEl || countdownStarted) return;
    countdownStarted = true;
    var storageKey = "resorse_cart_reserved_offer_end";

    function pad2(value) {
      return String(value).padStart(2, "0");
    }

    function getEndTime() {
      var stored = sessionStorage.getItem(storageKey);
      var end = stored ? parseInt(stored, 10) : 0;
      if (!end) {
        end = Date.now() + 10 * 60 * 1000;
        sessionStorage.setItem(storageKey, String(end));
      }
      return end;
    }

    function tick() {
      var secondsLeft = Math.max(0, Math.ceil((getEndTime() - Date.now()) / 1000));
      var minutes = Math.floor(secondsLeft / 60);
      var seconds = secondsLeft % 60;
      countdownEl.textContent = pad2(minutes) + ":" + pad2(seconds);
    }

    tick();
    window.setInterval(tick, 1000);
  }

  function formatMoney(cents) {
    var v = (cents / 100).toFixed(2);
    return moneyFmt
      .replace("{{amount}}", v)
      .replace("{{amount_no_decimals}}", String(Math.round(cents / 100)))
      .replace("{{amount_with_comma_separator}}", v.replace(".", ","))
      .replace("{{amount_no_decimals_with_comma_separator}}", String(Math.round(cents / 100)))
      .replace("{{currency}}", curCode)
      .replace("{{amount_no_decimals_without_trailing_zeros}}", String(cents / 100));
  }

  function escapeHtml(s) {
    if (typeof s !== "string") return String(s);
    return s.replace(/&/g, "&amp;").replace(/</g, "&lt;").replace(/>/g, "&gt;").replace(/"/g, "&quot;");
  }

  // Per-unit strikethrough price (cents) stored by the PDP bundle offer
  // as a hidden line property; 0 when the line was not added via a bundle.
  function itemBundleCompareCents(item) {
    var v = item && item.properties && item.properties._compare_unit_cents;
    var n = parseInt(v, 10);
    return n > 0 ? n : 0;
  }

  // /cart.js omits catalog compare_at prices; recover them only for products
  // present in the upsell catalog, preferring the exact variant price.
  function itemUpsellCompareCents(item) {
    for (var i = 0; i < upsellCatalog.length; i++) {
      var product = upsellCatalog[i];
      if (!product || String(product.id) !== String(item.product_id)) continue;
      var compare = parseInt(product.compare_at_price, 10) || 0;
      var variants = product.variants || [];
      for (var j = 0; j < variants.length; j++) {
        if (String(variants[j].id) === String(item.variant_id)) {
          compare = parseInt(variants[j].compare_at_price, 10) || compare;
          break;
        }
      }
      return compare;
    }
    return 0;
  }

  // Mini RC checkout discounts use these same Solo/Duo/Trio totals.
  var miniRcTiers = [{ qty: 1, total: 3299 }, { qty: 2, total: 5499 }, { qty: 3, total: 6999 }];

  function renderItem(item) {
    var isAlarm = item.handle === "offguard-personal-safety-alarm" || item.handle === "rechargeable-personal-safety-alarm-with-flashlight";
    var displayTitle = isAlarm && alarmProductTitle ? alarmProductTitle : item.product_title;
    var variantTitle = isAlarm && item.variant_title ? item.variant_title.replace(/\b(?:English|Taro)\b/g, "").trim() : item.variant_title;
    var isGift = item.variant_id === giftVariantId;
    var isService = item.handle === "shipping-protection";
    var hideProductLink = isGift || isService || item.handle === "construction-vehicle-toy-sets";
    var img = (typeof item.image === "string" && item.image) ? item.image : null;
    var imgHtml = img
      ? (hideProductLink
        ? '<img src="' + escapeHtml(img) + '" alt="" width="120" loading="lazy">'
        : '<a href="' + escapeHtml(item.url) + '" aria-hidden="true" tabindex="-1"><img src="' + escapeHtml(img) + '" alt="" width="120" loading="lazy"></a>')
      : '<div class="cart-pack__placeholder">No image</div>';
    var titleHtml = hideProductLink
      ? escapeHtml(displayTitle)
      : '<a href="' + escapeHtml(item.url) + '">' + escapeHtml(displayTitle) + '</a>';
    var variantHtml = variantTitle && variantTitle !== "Default Title" && variantTitle !== ""
      ? '<p class="cart-pack__variant">' + escapeHtml(variantTitle) + "</p>"
      : "";
    if (!isGift && !isService) variantHtml +=
        '<div class="cart-pack__qty">' +
        '<button type="button" class="cart-pack__qty-step" data-cart-qty-step="-1" aria-label="Decrease quantity">−</button>' +
        '<input id="qty-drawer-' + escapeHtml(item.key) + '" type="number" class="cart-pack__qty-input" data-cart-qty-input data-key="' +
        escapeHtml(item.key) + '" value="' + item.quantity + '" min="0" step="1" aria-label="Qty">' +
        '<button type="button" class="cart-pack__qty-step" data-cart-qty-step="1" aria-label="Increase quantity">+</button>' +
        "</div>";
    var compareHtml = "";
    var bundleCompare = isMiniRcLine(item) ? item.original_line_price : itemBundleCompareCents(item) * item.quantity;
    var upsellCompare = isMiniRcLine(item) ? 0 : itemUpsellCompareCents(item) * item.quantity;
    if (bundleCompare > item.final_line_price) {
      compareHtml = '<span class="cart-pack__compare">' + formatMoney(bundleCompare) + "</span>";
    } else if (upsellCompare > item.final_line_price) {
      compareHtml = '<span class="cart-pack__compare">' + formatMoney(upsellCompare) + "</span>";
    } else if (item.original_line_price !== item.final_line_price) {
      compareHtml = '<span class="cart-pack__compare">' + formatMoney(item.original_line_price) + "</span>";
    }
    return (
      '<li class="cart-pack' + (isGift ? ' cart-pack--gift' : '') + (isService ? ' cart-pack--service' : '') + '" data-cart-line-item data-key="' +
      escapeHtml(item.key) +
      '">' +
      '<figure class="cart-pack__media">' +
      imgHtml +
      "</figure>" +
      '<div class="cart-pack__body">' +
      '<div class="cart-pack__row-title">' +
      '<h2 class="cart-pack__title">' + titleHtml + "</h2>" +
      "</div>" +
      '<div class="cart-pack__variant-row">' + variantHtml + "</div>" +
      (isMiniRcLine(item) && lastCart.items.filter(isMiniRcLine).reduce(function (n, line) { return n + line.quantity; }, 0) === 1
        ? upsellBadgeHtml(1, lastCart.item_count, item, miniRcTiers)
        : "") +
      "</div>" +
      '<div class="cart-pack__aside">' +
      '<div class="cart-pack__price">' +
      compareHtml +
      formatMoney(item.final_line_price) +
      "</div>" +
      '<button type="button" class="cart-pack__remove" data-cart-remove aria-label="Remove pack" data-key="' +
      escapeHtml(item.key) +
      '">' + TRASH_ICON + '</button>' +
      "</div>" +
      "</li>"
    );
  }

  var TRASH_ICON = '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M3 6h18"/><path d="M8 6V4h8v2"/><path d="M19 6l-1 14H6L5 6"/><path d="M10 11v6M14 11v6"/></svg>';
  var TRUCK_ICON = '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round"><path d="M1 3h13v13H1z"/><path d="M14 8h4l3 3v5h-7z"/><circle cx="5.5" cy="18.5" r="1.8"/><circle cx="17.5" cy="18.5" r="1.8"/></svg>';
  var GIFT_ICON = '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round"><path d="M20 12v9H4v-9"/><path d="M2 7h20v5H2z"/><path d="M12 21V7"/><path d="M12 7H7.5a2.5 2.5 0 0 1 0-5C11 2 12 7 12 7z"/><path d="M12 7h4.5a2.5 2.5 0 0 0 0-5C13 2 12 7 12 7z"/></svg>';

  function milestoneHtml(label, icon, leftPct, reached) {
    return (
      '<div class="cart-drawer__milestone' + (reached ? " is-reached" : "") + (leftPct >= 98 ? " is-end" : "") + '" style="left:' + leftPct + '%">' +
      '<span class="cart-drawer__milestone-dot"></span>' +
      '<span class="cart-drawer__milestone-icon">' + icon + "</span>" +
      '<span class="cart-drawer__milestone-label">' + escapeHtml(label) + "</span>" +
      "</div>"
    );
  }

  function renderFreeShipping(cart, tier) {
    if (!freeShippingEl) return;
    // Gift threshold is optional; without it the bar degrades to the single
    // free-shipping milestone.
    var maxGoal = Math.max(freeShippingThreshold, giftThreshold);
    if (!maxGoal || !cart || !cart.items || !cart.items.length) {
      freeShippingEl.classList.remove("is-gift-unlocked");
      freeShippingEl.hidden = true;
      if (checkoutEl) {
        checkoutEl.classList.remove("is-gift-unlocked");
        checkoutEl.textContent = "CHECKOUT";
      }
      return;
    }

    var total = giftQualifyingTotal(cart);
    var alarmUnits = cart.items.filter(isAlarmLine).reduce(function (n, item) { return n + item.quantity; }, 0);
    var giftUnlocked = giftThreshold > 0 && total >= giftThreshold && (!alarmUnits || alarmUnits >= 3);
    freeShippingEl.classList.toggle("is-gift-unlocked", giftUnlocked);
    if (checkoutEl) {
      checkoutEl.classList.toggle("is-gift-unlocked", giftUnlocked);
      checkoutEl.textContent = giftUnlocked ? "CHECKOUT AND GET FREE MYSTERY GIFT" : "CHECKOUT";
    }
    var nextGoal = 0;
    var nextLabel = "";
    if (freeShippingThreshold && total < freeShippingThreshold) {
      nextGoal = freeShippingThreshold;
      nextLabel = shippingLabel;
    } else if (giftThreshold && total < giftThreshold) {
      nextGoal = giftThreshold;
      nextLabel = giftLabel;
    }

    var text = nextGoal
      ? "Spend <strong>" + escapeHtml(formatMoney(nextGoal - total)) + "</strong> to unlock <strong>" + escapeHtml(nextLabel) + "</strong>!"
      : giftUnlocked ? "Mystery Gift Unlocked 🎁" : "You unlocked all rewards! 🎉";

    // Milestones sit at fixed 50% / 100% marks, so the fill is piecewise:
    // half the bar per stage regardless of the actual amounts.
    var shipPct = !freeShippingThreshold ? 0 : giftThreshold ? 50 : 100;
    var fillPct;
    if (!freeShippingThreshold || total >= freeShippingThreshold) {
      fillPct = giftThreshold
        ? shipPct + (100 - shipPct) * Math.min(1, (total - freeShippingThreshold) / (giftThreshold - freeShippingThreshold))
        : 100;
    } else {
      fillPct = shipPct * (total / freeShippingThreshold);
    }

    var milestones = "";
    if (freeShippingThreshold) {
      milestones += milestoneHtml(shippingLabel, TRUCK_ICON, shipPct, total >= freeShippingThreshold);
    }
    if (giftThreshold) {
      milestones += milestoneHtml(giftLabel, GIFT_ICON, 100, giftUnlocked);
    }

    freeShippingEl.hidden = false;
    freeShippingEl.innerHTML =
      '<p class="cart-drawer__rewards-text">' + text + "</p>" +
      '<div class="cart-drawer__rewards-track">' +
      '<div class="cart-drawer__rewards-fill" style="width:' + Math.max(0, Math.min(100, Math.round(fillPct))) + '%"></div>' +
      milestones +
      "</div>";
  }

  // Cache of variant id -> compare_at_price (cents); 0 means no compare price.
  var compareCache = {};

  function sumCompareTotal(cart) {
    var items = (cart && cart.items) || [];
    var total = 0;
    items.forEach(function (it) {
      // Prefer the bundle offer's own strikethrough price (line property)
      // so the drawer matches the compare price shown on the PDP bundle card.
      var c = isMiniRcLine(it) ? it.price : itemBundleCompareCents(it) || compareCache[it.variant_id];
      var base = c && c > it.price ? c : it.price;
      total += base * it.quantity;
    });
    return total;
  }

  function renderWas(cart, tier) {
    if (!wasEl) return;
    var items = (cart && cart.items) || [];
    // With a pack tier the compare price is the pack's, not the sum of lines.
    if (tier && items.length) {
      var tierCompare = parseInt(tier.compare, 10) || 0;
      var tierTotal = parseInt(tier.total, 10) || cart.total_price;
      wasEl.hidden = tierCompare <= tierTotal;
      wasEl.textContent = formatMoney(tierCompare);
      if (saveBadgeEl) {
        saveBadgeEl.hidden = !tier.save;
        saveBadgeEl.textContent = tier.save || "";
      }
      return;
    }
    if (!items.length) {
      wasEl.hidden = true;
      if (saveBadgeEl) saveBadgeEl.hidden = true;
      return;
    }

    var missingHandles = {};
    items.forEach(function (it) {
      if (compareCache[it.variant_id] === undefined && it.handle) {
        missingHandles[it.handle] = true;
      }
    });

    var handles = Object.keys(missingHandles);
    if (handles.length === 0) {
      applyWas(cart);
      return;
    }

    var pending = handles.length;
    handles.forEach(function (h) {
      fetch("/products/" + h + ".js", { headers: { Accept: "application/json" } })
        .then(function (r) { return r.json(); })
        .then(function (pd) {
          (pd.variants || []).forEach(function (v) {
            compareCache[v.id] = v.compare_at_price ? v.compare_at_price : 0;
          });
        })
        .catch(function () {})
        .then(function () {
          pending--;
          if (pending === 0 && cart === lastCart) {
            items.forEach(function (it) {
              if (compareCache[it.variant_id] === undefined) compareCache[it.variant_id] = 0;
            });
            applyWas(cart);
          }
        });
    });
  }

  function applyWas(cart) {
    if (!wasEl) return;
    var compareTotal = sumCompareTotal(cart);
    var showWas = compareTotal > cart.total_price;
    if (showWas) {
      wasEl.hidden = false;
      wasEl.textContent = formatMoney(compareTotal);
    } else {
      wasEl.hidden = true;
    }
    if (saveBadgeEl) {
      var savedPct = compareTotal > 0 ? Math.round((compareTotal - cart.total_price) * 100 / compareTotal) : 0;
      var lbl = showWas && savedPct > 0 ? "SAVE " + savedPct + "%" : "";
      if (lbl) {
        saveBadgeEl.hidden = false;
        saveBadgeEl.textContent = lbl;
      } else {
        saveBadgeEl.hidden = true;
      }
    }
  }

  function renderUpsells(cart) {
    if (!upsellsEl || !upsellsList) return;

    var miniUnits = (cart.items || []).filter(isMiniRcLine).reduce(function (sum, item) { return sum + item.quantity; }, 0);
    miniRcUpsellStep = miniUnits ? nextTierStep(miniUnits, miniRcTiers) : null;
    if (miniUnits >= 3) {
      renderedUpsellProducts = [];
      upsellsEl.hidden = true;
      return;
    }
    var cartIds = {};
    if (cart && cart.items) {
      cart.items.forEach(function (item) {
        cartIds[item.product_id] = true;
      });
    }

    var qualified = upsellProducts.filter(function (p) {
      return p && p.id && p.id !== currentProductId && !cartIds[p.id] &&
        (p.variants || []).some(function (v) { return v.available; });
    });

    if (qualified.length === 0) {
      upsellsEl.hidden = true;
      return;
    }

    renderUpsellCards(qualified);
  }

  function renderUpsellCards(products) {
    upsellsEl.hidden = false;
    renderedUpsellProducts = products;
    if (upsellIndex >= products.length) upsellIndex = 0;
    var p = products[upsellIndex];
    var img = p.image || "";
    var imgHtml = img
      ? '<img src="' + escapeHtml(img) + '" alt="" loading="lazy">'
      : '<div class="cart-drawer__upsell-card-img-placeholder">No image</div>';

    // Always add-to-cart only (no redirect to product page).
    // Pick the first available variant, or fall back to the first one.
    var variants = p.variants || [];
    var chosen = null;
    for (var i = 0; i < variants.length; i++) {
      if (variants[i] && variants[i].available) { chosen = variants[i]; break; }
    }
    if (!chosen) chosen = variants[0] || null;
    var isEyeMask = p.handle === "3d-light-blocking-sleep-eye-mask";
    var step = isMiniRcLine(p) && miniRcUpsellStep;
    var variantId = chosen ? chosen.id : "";
    var price = chosen && typeof chosen.price === "number" ? chosen.price : p.price;
    var compare = chosen && typeof chosen.compare_at_price === "number" && chosen.compare_at_price
      ? chosen.compare_at_price
      : (p.compare_at_price || (isEyeMask ? 1999 : 0));
    if (step) { price = step.amount; compare = 0; }
    var variantHtml = "";
    if (variants.length > 1) {
      variantHtml =
        '<label class="cart-drawer__upsell-card-option">' + (isEyeMask ? "" : "Option:") +
        '<select data-upsell-variant aria-label="Choose an option">' +
        variants.map(function (v) {
          var variantTitle = isEyeMask ? (v.title || "").trim().split(/\s+/)[0] : v.title;
          return '<option value="' + v.id + '" data-price="' + (step ? step.amount : v.price) + '" data-compare="' +
            (step ? 0 : (v.compare_at_price || p.compare_at_price || (isEyeMask ? 1999 : 0))) + '"' +
            (v.id === variantId ? " selected" : "") + (v.available ? "" : " disabled") + '>' +
            escapeHtml(variantTitle) + "</option>";
        }).join("") +
        "</select></label>";
    }

    upsellsList.innerHTML =
      '<button type="button" class="cart-drawer__upsell-nav" data-upsell-prev aria-label="Previous recommendation"' +
      (products.length > 1 ? "" : " disabled") + '>&larr;</button>' +
      '<div class="cart-drawer__upsell-viewport" aria-live="polite">' +
        '<div class="cart-drawer__upsell-card" data-upsell-slide="' + (upsellIndex + 1) + ' of ' + products.length + '"' +
        (isEyeMask ? ' data-upsell-eye-mask' : "") + '>' +
        '<span class="cart-drawer__upsell-card-img">' + imgHtml + "</span>" +
        '<div class="cart-drawer__upsell-card-body">' +
        '<span class="cart-drawer__upsell-card-title">' + escapeHtml(p.title) + "</span>" +
        '<div class="cart-drawer__upsell-card-prices">' + upsellPriceHtml(price, compare) + "</div>" +
        (isEyeMask ? "" : variantHtml) +
        '<div class="cart-drawer__upsell-card-controls">' +
        (isEyeMask ? variantHtml : isMiniRcLine(p) ? "" :
        '<div class="cart-drawer__upsell-card-qty">' +
        '<button type="button" class="cart-drawer__upsell-card-qty-step" data-upsell-qty-step="-1" aria-label="Decrease quantity">\u2212</button>' +
        '<input type="number" class="cart-drawer__upsell-card-qty-input" data-upsell-qty value="1" min="1" step="1" aria-label="Qty" readonly>' +
        '<button type="button" class="cart-drawer__upsell-card-qty-step" data-upsell-qty-step="1" aria-label="Increase quantity">+</button>' +
        "</div>") +
        '<button type="button" class="cart-drawer__upsell-card-add" data-upsell-add data-product-id="' + p.id + '" data-variant-id="' + variantId + '">Add to cart</button>' +
        "</div>" +
        "</div>" +
        "</div>" +
      "</div>" +
      '<button type="button" class="cart-drawer__upsell-nav" data-upsell-next aria-label="Next recommendation"' +
      (products.length > 1 ? "" : " disabled") + '>&rarr;</button>';
  }

  function upsellPriceHtml(price, compare) {
    var current = '<span class="cart-drawer__upsell-card-price">' + formatMoney(price) + "</span>";
    var html = current;
    if (compare && compare > price) {
      var previous = '<span class="cart-drawer__upsell-card-compare">' + formatMoney(compare) + "</span>";
      html = current + previous;
      html += '<span class="cart-drawer__upsell-card-saving">You save ' +
        Math.round((compare - price) * 100 / compare) + "%</span>";
    }
    return html;
  }

  // Highest tier whose qty fits in the cart; null when the cart is smaller
  // than the first tier or the tiers are not configured.
  // Price gap to the next pack, so the upsell badge quotes the real jump
  // instead of a hardcoded amount that drifts when prices change.
  function nextTierStep(units, tiers) {
    tiers = tiers || bundleTiers;
    for (var i = 0; i < tiers.length; i++) {
      if (tiers[i].qty > units) {
        var cur = tierFor(units, tiers);
        var curTotal = (cur && parseInt(cur.total, 10)) || 0;
        return {
          qty: tiers[i].qty,
          total: parseInt(tiers[i].total, 10) || 0,
          amount: (parseInt(tiers[i].total, 10) || 0) - curTotal,
        };
      }
    }
    return null;
  }

  function upsellBadgeHtml(units, totalItems, line, tiers) {
    var step = nextTierStep(units, tiers);
    if (!step || !qtyUpsellText || step.amount <= 0) return "";
    var label = escapeHtml(qtyUpsellText.replace("{{amount}}", formatMoney(step.amount)));
    var currentTier = tierFor(units, tiers);
    var shippingLocked = freeShippingThreshold > 0 &&
      ((currentTier && parseInt(currentTier.total, 10)) || 0) < freeShippingThreshold;
    // item_count is Shopify's sum of quantities across bundle and upsell lines.
    if (shippingLocked && step.total >= freeShippingThreshold) label += " + Free Shipping!";
    // Only the jump that actually crosses the gift threshold gets the mention.
    // Explicit <br> so it always lands on exactly two lines.
    if (giftThreshold && step.total >= giftThreshold && units < 3) label += "<br>+ Free Gift 🎁";
    return '<button type="button" class="cart-pack__qty-upsell" data-cart-group-upsell data-key="' +
      escapeHtml(line.key) + '" data-quantity="' + line.quantity + '">' + label + "</button>";
  }

  function tierFor(units, tiers) {
    tiers = tiers || bundleTiers;
    var match = null;
    for (var i = 0; i < tiers.length; i++) {
      if (tiers[i].qty <= units) match = tiers[i];
    }
    if (!match || units === match.qty || !tiers.length) return match;
    // Past the biggest pack the price has to keep growing: the extra units are
    // charged at the single-unit tier instead of staying frozen at the top pack.
    var single = tiers[0];
    var extra = units - match.qty;
    return {
      qty: units,
      title: match.title,
      total: (parseInt(match.total, 10) || 0) + extra * (parseInt(single.total, 10) || 0),
      compare: (parseInt(match.compare, 10) || 0) + extra * (parseInt(single.compare, 10) || 0),
      save: match.save,
      code: match.code,
    };
  }

  // All bundle lines collapse into one card: the shopper buys "a pack", not
  // N separate variants.
  function renderGroup(cart, tier, totalItems) {
    var items = cart.items;
    var first = items[0];
    var last = items[items.length - 1];
    var units = cart.item_count;
    var img = (typeof first.image === "string" && first.image) ? first.image : null;

    // Each bundle variant on its own row, keeping the ×N suffix for repeated units.
    var variants = items
      .map(function (it) {
        var t = it.variant_title && it.variant_title !== "Default Title" ? it.variant_title : it.product_title;
        t = it.quantity > 1 ? t + " \u00d7" + it.quantity : t;
        return '<p class="cart-pack__variant">' + escapeHtml(t) + "</p>";
      })
      .join("");

    var compare = parseInt(tier.compare, 10) || 0;
    var total = parseInt(tier.total, 10) || cart.total_price;

    return (
      '<li class="cart-pack" data-cart-line-item>' +
      '<figure class="cart-pack__media">' +
      (img
        ? '<img src="' + escapeHtml(img) + '" alt="" width="120" loading="lazy">'
        : '<div class="cart-pack__placeholder">No image</div>') +
      "</figure>" +
      '<div class="cart-pack__body">' +
      '<div class="cart-pack__row-title">' +
      '<h2 class="cart-pack__title"><a href="' + escapeHtml(first.url) + '">' +
      escapeHtml(tier.title || first.product_title) + "</a></h2>" +
      "</div>" +
      '<div class="cart-pack__variant-row">' +
      '<div class="cart-pack__variant-list">' + variants + "</div>" +
      '<div class="cart-pack__qty">' +
      '<button type="button" class="cart-pack__qty-step" data-cart-group-step="-1" aria-label="Decrease quantity">\u2212</button>' +
      '<input type="number" class="cart-pack__qty-input" value="' + units + '" min="1" step="1" aria-label="Qty" readonly>' +
      '<button type="button" class="cart-pack__qty-step" data-cart-group-step="1" aria-label="Increase quantity">+</button>' +
      "</div>" +
      "</div>" +
      upsellBadgeHtml(units, totalItems, first) +
      "</div>" +
      '<div class="cart-pack__aside">' +
      '<div class="cart-pack__price">' +
      (compare > total ? '<span class="cart-pack__compare">' + formatMoney(compare) + "</span>" : "") +
      formatMoney(total) +
      "</div>" +
      '<button type="button" class="cart-pack__remove" data-cart-group-remove aria-label="Remove pack">' + TRASH_ICON + "</button>" +
      "</div>" +
      '<input type="hidden" data-group-first-key value="' + escapeHtml(first.key) + '">' +
      '<input type="hidden" data-group-last-key value="' + escapeHtml(last.key) + '">' +
      "</li>"
    );
  }

  function isBundleLine(item) {
    var p = (item && item.properties) || {};
    return !!(p.Offer || p._save_label || p._compare_unit_cents);
  }

  function isMiniRcLine(item) {
    return /^offroar-yellow-[13456]d-mini-rc-(forklift|dump-truck|excavator|crane|bulldozer)$/.test(item.handle || "");
  }

  function isAlarmLine(item) {
    return item.handle === "offguard-personal-safety-alarm" || item.handle === "rechargeable-personal-safety-alarm-with-flashlight";
  }

  function bundleUnits(items) {
    var n = 0;
    for (var i = 0; i < items.length; i++) {
      if (isBundleLine(items[i])) n += items[i].quantity;
    }
    return n;
  }

  function giftLine(cart) {
    for (var i = 0; i < cart.items.length; i++) {
      if (cart.items[i].variant_id === giftVariantId) return cart.items[i];
    }
    return null;
  }

  function giftQualifyingTotal(cart) {
    return cart.items.reduce(function (total, item) {
      return total + (item.variant_id === giftVariantId || item.handle === "shipping-protection" ? 0 : item.final_line_price);
    }, 0);
  }

  function syncGift(cart) {
    if (!giftVariantId || giftSyncing || !cart || !cart.items) return;
    var line = giftLine(cart);
    var alarmUnits = cart.items.filter(isAlarmLine).reduce(function (n, item) { return n + item.quantity; }, 0);
    var qualifies = giftThreshold > 0 && giftQualifyingTotal(cart) >= giftThreshold && (!alarmUnits || alarmUnits >= 3);
    if (qualifies && !line) {
      giftSyncing = true;
      fetch("/cart/add.js", {
        method: "POST",
        headers: { "Content-Type": "application/json", Accept: "application/json" },
        body: JSON.stringify({ items: [{ id: giftVariantId, quantity: 1 }] }),
      })
        .then(function (r) {
          if (!r.ok) return r.json().then(function (j) {
            throw new Error((j && (j.description || j.message)) || "Could not add free gift");
          });
        })
        .then(fetchCart)
        .then(function (freshCart) {
          render(freshCart);
          updateCount(freshCart.item_count);
        })
        .catch(function (err) {
          console.error(err);
        })
        .then(function () {
          giftSyncing = false;
        });
    } else if (!qualifies && line) {
      giftSyncing = true;
      fetch("/cart/change.js", {
        method: "POST",
        headers: { "Content-Type": "application/json", Accept: "application/json" },
        body: JSON.stringify({ id: line.key, quantity: 0 }),
      })
        .then(fetchCart)
        .then(function (freshCart) {
          render(freshCart);
          updateCount(freshCart.item_count);
        })
        .catch(function () {})
        .then(function () {
          giftSyncing = false;
        });
    }
  }

  function syncRoadSigns(cart) {
    if (roadSignsSyncing || cart.items.some(isMiniRcLine)) return;
    var updates = {};
    cart.items.forEach(function (item) {
      if (item.handle === "construction-vehicle-toy-sets") updates[item.key] = 0;
    });
    if (!Object.keys(updates).length) return;
    roadSignsSyncing = true;
    fetch("/cart/update.js", {
      method: "POST",
      headers: { "Content-Type": "application/json", Accept: "application/json" },
      body: JSON.stringify({ updates: updates }),
    })
      .then(function (r) {
        if (!r.ok) throw new Error("Could not remove the Road Signs gift. Please try again.");
        return r.json();
      })
      .then(function (freshCart) {
        render(freshCart);
        updateCount(freshCart.item_count);
      })
      .catch(function (err) { window.alert(err.message); })
      .then(function () { roadSignsSyncing = false; });
  }

  var lastCart = { items: [] };

  function render(cart) {
    if (!cart || !cart.items) return;
    lastCart = cart;
    if (protectionEl) protectionEl.hidden = !cart.items.length || cart.items.some(function (item) { return item.handle === "shipping-protection"; });
    if (cart.items.length === 0) {
      itemsEl.innerHTML = '<li class="cart-drawer__empty">' + escapeHtml(emptyText) + "</li>";
    } else {
      var packItems = cart.items.filter(isBundleLine);
      var otherItems = cart.items.filter(function (it) { return !isBundleLine(it); });
      var tier = packItems.length && !cart.items.some(isMiniRcLine) && !cart.items.some(isAlarmLine) ? tierFor(bundleUnits(cart.items)) : null;
      itemsEl.innerHTML =
        (tier ? renderGroup({ items: packItems, item_count: bundleUnits(cart.items) }, tier, cart.item_count) : "") +
        (tier ? otherItems : cart.items).map(renderItem).join("");
    }
    var othersTotal = 0;
    cart.items.forEach(function (it) {
      if (!isBundleLine(it)) othersTotal += it.final_line_price;
    });
    var shownTotal = tier ? (parseInt(tier.total, 10) || 0) + othersTotal : cart.total_price;
    subtotalEl.textContent = formatMoney(shownTotal);
    if (alarmUpgradeEl) {
      var alarms = cart.items.filter(isAlarmLine);
      var alarmUnits = alarms.reduce(function (n, item) { return n + item.quantity; }, 0);
      alarmUpgradeEl.innerHTML = alarms.length ? upsellBadgeHtml(alarmUnits, alarmUnits, alarms[0]) : "";
      alarmUpgradeEl.hidden = !alarmUpgradeEl.innerHTML;
    }
    // Non-bundle products keep their real price on both sides of the compare.
    var shownTier = tier && {
      total: shownTotal,
      compare: (parseInt(tier.compare, 10) || 0) + othersTotal,
      save: tier.save,
    };
    renderWas(cart, shownTier);
    renderFreeShipping(cart, shownTier);
    renderUpsells(cart);
    syncGift(cart);
    syncRoadSigns(cart);
  }

  function updateCount(n) {
    document.querySelectorAll(".site-header__cart-count").forEach(function (el) {
      el.textContent = "(" + n + ")";
    });
  }

  function open() {
    initCountdown();
    lastFocusedEl = document.activeElement;
    panel.classList.add("is-open");
    backdrop.classList.add("is-open");
    panel.setAttribute("aria-hidden", "false");
    document.body.classList.add("cart-drawer-open");
    var first = panel.querySelector(focusableSelector);
    if (first) first.focus();
  }

  function close() {
    panel.classList.remove("is-open");
    backdrop.classList.remove("is-open");
    panel.setAttribute("aria-hidden", "true");
    document.body.classList.remove("cart-drawer-open");
    if (lastFocusedEl && lastFocusedEl.focus) {
      lastFocusedEl.focus();
      lastFocusedEl = null;
    }
  }

  function fetchCart() {
    return fetch("/cart.js", { headers: { Accept: "application/json" } }).then(function (r) {
      return r.json();
    });
  }

  function reloadAndOpen() {
    fetchCart().then(function (cart) {
      render(cart);
      updateCount(cart.item_count);
      open();
    });
  }

  function clearCart() {
    fetch("/cart/clear.js", { method: "POST", headers: { Accept: "application/json" } })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        render(cart);
        updateCount(cart.item_count);
      });
  }

  function changeItem(key, qty) {
    fetch("/cart/change.js", {
      method: "POST",
      headers: { "Content-Type": "application/x-www-form-urlencoded", Accept: "application/json" },
      body: new URLSearchParams({ id: key, quantity: qty }),
    })
      .then(function (r) {
        if (!r.ok) return r.json().then(function (j) { throw j; });
        return r.json();
      })
      .then(function (cart) {
        render(cart);
        updateCount(cart.item_count);
        syncTierDiscount(cart);
      })
      .catch(function (err) {
        var msg = "Could not update cart";
        if (err && err.message) msg = err.message;
        else if (err && err.description) msg = err.description;
        else if (err && err.errors) msg = typeof err.errors === "string" ? err.errors : JSON.stringify(err.errors);
        window.alert(msg);
      });
  }

  async function addShippingProtection(button) {
    if (button.disabled || !lastCart.items.length || lastCart.items.some(function (item) { return item.handle === "shipping-protection"; })) return;
    var variantId = Number(button.getAttribute("data-variant-id"));
    if (!Number.isSafeInteger(variantId) || variantId <= 0) {
      window.alert("Delivery assistance is unavailable. Please try again.");
      return;
    }
    button.disabled = true;
    try {
      var response = await fetch("/cart/add.js", {
        method: "POST",
        headers: { "Content-Type": "application/json", Accept: "application/json" },
        body: JSON.stringify({ items: [{ id: variantId, quantity: 1 }] }),
      });
      if (!response.ok) {
        var error = await response.json();
        throw new Error(error.description || error.message || "Could not add delivery assistance.");
      }
      var cart = await fetchCart();
      render(cart);
      updateCount(cart.item_count);
    } catch (err) {
      window.alert(err.message || "Could not add delivery assistance.");
    } finally {
      button.disabled = false;
    }
  }

  async function upgradeAlarm(button) {
    if (button.disabled) return;
    var alarms = lastCart.items.filter(isAlarmLine);
    var units = alarms.reduce(function (n, item) { return n + item.quantity; }, 0);
    var next = nextTierStep(units);
    if (!alarms.length || !next) return;
    button.disabled = true;
    try {
      var productResponse = await fetch("/products/" + alarms[0].handle + ".js", { headers: { Accept: "application/json" } });
      if (!productResponse.ok) throw new Error("Could not load available colours. Please try again.");
      var product = await productResponse.json();
      var available = (product.variants || []).filter(function (v) { return v.available && Number.isSafeInteger(Number(v.id)) && Number(v.id) > 0; });
      if (!available.length) throw new Error("OFFGUARD is currently unavailable.");
      var variant = available[Math.floor(Math.random() * available.length)];
      var response = await fetch("/cart/add.js", {
        method: "POST",
        headers: { "Content-Type": "application/json", Accept: "application/json" },
        body: JSON.stringify({ items: [{ id: Number(variant.id), quantity: 1, properties: { Offer: next.qty === 2 ? "OFFGUARD Pack Duo" : "OFFGUARD Pack Trio" } }] }),
      });
      if (!response.ok) {
        var error = await response.json();
        throw new Error(error.description || error.message || "Could not add OFFGUARD.");
      }
      var code = tierFor(next.qty).code;
      var cart = await applyDiscount(code);
      if (cart) {
        lastAppliedCode = code;
        render(cart);
        updateCount(cart.item_count);
      }
    } catch (err) {
      window.alert(err.message || "Could not upgrade your pack.");
    } finally {
      button.disabled = false;
    }
  }

  async function upgradeMiniRc(line, button) {
    if (button.disabled) return;
    button.disabled = true;
    try {
      var select = document.querySelector('.bundle-card[data-bundle-card="2"] [data-bundle-product-select][data-bundle-slot="2"]');
      var option = select && select.options[select.selectedIndex];
      var variantId = option ? Number(option.value) : 0;
      if (!select || variantId === line.variant_id) {
        var handle = line.handle === "offroar-yellow-4d-mini-rc-excavator"
          ? "offroar-yellow-1d-mini-rc-forklift" : "offroar-yellow-4d-mini-rc-excavator";
        var productResponse = await fetch("/products/" + handle + ".js", { headers: { Accept: "application/json" } });
        if (!productResponse.ok) throw new Error("Could not load the second toy. Please try again.");
        var product = await productResponse.json();
        var variant = (product.variants || []).find(function (v) { return v.available; });
        variantId = variant ? Number(variant.id) : 0;
      } else if (!option || option.disabled || option.getAttribute("data-available") !== "true") {
        throw new Error("The selected second toy is unavailable. Choose another model in Pack Duo.");
      }
      if (!Number.isSafeInteger(variantId) || variantId <= 0 || variantId === line.variant_id) {
        throw new Error("A different second toy is unavailable. Please choose another model.");
      }
      var response = await fetch("/cart/add.js", {
        method: "POST",
        headers: { "Content-Type": "application/json", Accept: "application/json" },
        body: JSON.stringify({ items: [{ id: variantId, quantity: 1, properties: { Offer: "Pack Duo — 2 toys" } }] }),
      });
      if (!response.ok) {
        var error = await response.json();
        throw new Error(error.description || error.message || "Could not add the second toy.");
      }
      var cart = await applyDiscount("mini-rc-duo");
      if (cart) {
        lastAppliedCode = "mini-rc-duo";
        render(cart);
        updateCount(cart.item_count);
      }
    } catch (err) {
      window.alert(err.message || "Could not add the second toy.");
    } finally {
      button.disabled = false;
    }
  }

  function applyDiscount(code, silent) {
    function fallback() {
      if (silent) return null;
      var here = location.pathname + location.search;
      if (here.indexOf("cart=open") === -1) {
        here += (here.indexOf("?") >= 0 ? "&" : "?") + "cart=open";
      }
      window.location.href =
        shopUrl + "/discount/" + encodeURIComponent(code) + "?redirect=" + encodeURIComponent(here);
      return null;
    }
    return fetch("/cart/update.js", {
      method: "POST",
      headers: { "Content-Type": "application/json", Accept: "application/json" },
      body: JSON.stringify({ discount: code }),
    })
      .then(function (r) {
        return r.ok ? r.json() : fallback();
      })
      .catch(fallback);
  }

  // The bundle discount code belongs to the tier, so changing the quantity in
  // the cart has to swap the code too or checkout keeps the old pack price.
  var lastAppliedCode = "";

  function syncTierDiscount(cart) {
    var items = cart.items || [];
    var miniItems = items.filter(isMiniRcLine);
    var alarmUnits = items.filter(isAlarmLine).reduce(function (n, item) { return n + item.quantity; }, 0);
    var tier = miniItems.length ? null : tierFor(alarmUnits || bundleUnits(items));
    var miniUnits = miniItems.reduce(function (sum, item) { return sum + item.quantity; }, 0);
    var code = miniItems.length
      ? (miniUnits === 1 ? "mini-rc-solo" : miniUnits === 2 ? "mini-rc-duo" : miniUnits >= 3 ? "mini-rc-trio" : "")
      : (tier && tier.code) || "";
    var activeAlarmCode = (cart.discount_codes || []).some(function (discount) { return /^offguard-/.test(discount.code); });
    if (code === lastAppliedCode && !(activeAlarmCode && !code)) return;
    if (!code && !activeAlarmCode && !/^offguard-/.test(lastAppliedCode)) return;
    lastAppliedCode = code;
    applyDiscount(code, true).then(function (c) {
      if (!c) return;
      render(c);
      updateCount(c.item_count);
    });
  }

  var CartDrawer = {
    open: open,
    close: close,
    fetchCart: fetchCart,
    render: render,
    updateCount: updateCount,
    reloadAndOpen: reloadAndOpen,
    afterAdd: function (discountCode) {
      var code = (discountCode || "").trim();
      if (code) {
        lastAppliedCode = code;
        applyDiscount(code).then(function (cart) {
          if (!cart) return;
          render(cart);
          updateCount(cart.item_count);
          open();
        });
        return;
      }
      reloadAndOpen();
    },
    formatMoney: formatMoney,
  };

  window.CartDrawer = CartDrawer;

  backdrop.addEventListener("click", close);

  var closeBtn = drawer.querySelector("[data-cart-drawer-close]");
  if (closeBtn) closeBtn.addEventListener("click", close);

  document.addEventListener("keydown", function (e) {
    if (e.key === "Escape") {
      var aria = panel.getAttribute("aria-hidden");
      if (aria === "false") close();
    }
  });

  panel.addEventListener("keydown", function (e) {
    if (e.key !== "Tab") return;
    var focusable = panel.querySelectorAll(focusableSelector);
    if (!focusable.length) return;
    var first = focusable[0];
    var last = focusable[focusable.length - 1];
    if (e.shiftKey) {
      if (document.activeElement === first) {
        e.preventDefault();
        last.focus();
      }
    } else {
      if (document.activeElement === last) {
        e.preventDefault();
        first.focus();
      }
    }
  });

  document.addEventListener("click", function (e) {
    var t = e.target.closest("[data-cart-drawer-open]");
    if (t) {
      e.preventDefault();
      fetchCart().then(function (cart) {
        render(cart);
        updateCount(cart.item_count);
        open();
      });
    }
  });

  if (itemsEl) {
    itemsEl.addEventListener("change", function (e) {
      var inp = e.target.closest("[data-cart-qty-input]");
      if (!inp) return;
      var key = inp.getAttribute("data-key");
      var qty = parseInt(inp.value, 10);
      if (isNaN(qty) || qty < 0) qty = 0;
      changeItem(key, qty);
    });

    itemsEl.addEventListener("click", function (e) {
      var groupUpsell = e.target.closest("[data-cart-group-upsell]");
      if (groupUpsell) {
        e.preventDefault();
        var line = lastCart.items.find(function (item) { return item.key === groupUpsell.getAttribute("data-key"); });
        if (line && isMiniRcLine(line)) {
          upgradeMiniRc(line, groupUpsell);
          return;
        }
        changeItem(groupUpsell.getAttribute("data-key"), parseInt(groupUpsell.getAttribute("data-quantity"), 10) + 1);
        return;
      }
      var step = e.target.closest("[data-cart-qty-step]");
      if (step) {
        e.preventDefault();
        var input = step.parentNode.querySelector("[data-cart-qty-input]");
        var nextQty = Math.max(0, (parseInt(input.value, 10) || 0) + parseInt(step.getAttribute("data-cart-qty-step"), 10));
        input.value = String(nextQty);
        changeItem(input.getAttribute("data-key"), nextQty);
        return;
      }
      var gstep = e.target.closest("[data-cart-group-step]");
      if (gstep) {
        e.preventDefault();
        var card = gstep.closest(".cart-pack");
        var dir = parseInt(gstep.getAttribute("data-cart-group-step"), 10);
        // +1 grows the first line, -1 shrinks the last one, so the pack
        // quantity moves one unit at a time across however many variant lines.
        var target = card.querySelector(dir > 0 ? "[data-group-first-key]" : "[data-group-last-key]");
        var line = null;
        for (var i = 0; i < lastCart.items.length; i++) {
          if (lastCart.items[i].key === target.value) line = lastCart.items[i];
        }
        if (!line) return;
        changeItem(line.key, Math.max(0, line.quantity + dir));
        return;
      }
      var grm = e.target.closest("[data-cart-group-remove]");
      if (grm) {
        e.preventDefault();
        clearCart();
        return;
      }
      var bump = e.target.closest("[data-cart-qty-upsell]");
      if (bump) {
        e.preventDefault();
        changeItem(bump.getAttribute("data-key"), 2);
        return;
      }
      var rm = e.target.closest("[data-cart-remove]");
      if (!rm) return;
      e.preventDefault();
      changeItem(rm.getAttribute("data-key"), 0);
    });
  }

  if (alarmUpgradeEl) {
    alarmUpgradeEl.addEventListener("click", function (e) {
      var button = e.target.closest("[data-cart-group-upsell]");
      if (button) upgradeAlarm(button);
    });
  }

  if (protectionEl) {
    protectionEl.querySelector("[data-cart-protection-add]").addEventListener("click", function () {
      addShippingProtection(this);
    });
  }

  if (upsellsList) {
    upsellsList.addEventListener("click", function (e) {
      var direction = e.target.closest("[data-upsell-prev]") ? -1 :
        (e.target.closest("[data-upsell-next]") ? 1 : 0);
      if (direction && renderedUpsellProducts.length > 1) {
        upsellIndex = (upsellIndex + direction + renderedUpsellProducts.length) % renderedUpsellProducts.length;
        renderUpsellCards(renderedUpsellProducts);
        return;
      }
      var stepEl = e.target.closest("[data-upsell-qty-step]");
      if (stepEl) {
        var qtyField = stepEl.closest(".cart-drawer__upsell-card").querySelector("[data-upsell-qty]");
        var q = parseInt(qtyField.value, 10);
        if (isNaN(q)) q = 1;
        q += parseInt(stepEl.getAttribute("data-upsell-qty-step"), 10);
        if (q < 1) q = 1;
        qtyField.value = q;
        return;
      }
      var btn = e.target.closest("[data-upsell-add]");
      if (!btn) return;
      e.preventDefault();
      if (upsellAdding || btn.disabled) return;
      var variantId = Number(btn.getAttribute("data-variant-id"));
      var product = renderedUpsellProducts.find(function (p) { return String(p.id) === btn.getAttribute("data-product-id"); });
      if (!Number.isSafeInteger(variantId) || variantId <= 0 || !product ||
          !product.variants.some(function (v) { return v.id === variantId && v.available; })) return;
      var isMini = isMiniRcLine(product);
      var miniUnits = lastCart.items.filter(isMiniRcLine).reduce(function (sum, item) { return sum + item.quantity; }, 0);
      if (isMini && miniUnits >= 3) return;
      var discountCode = isMini ? (miniUnits === 0 ? "mini-rc-solo" : miniUnits === 1 ? "mini-rc-duo" : "mini-rc-trio") : "";
      var card = btn.closest(".cart-drawer__upsell-card");
      var qtyInput = card && card.querySelector("[data-upsell-qty]");
      var qty = qtyInput ? parseInt(qtyInput.value, 10) : 1;
      if (isNaN(qty) || qty < 1) qty = 1;
      if (isMini) qty = 1;
      upsellAdding = true;
      btn.disabled = true;
      fetch("/cart/add.js", {
        method: "POST",
        headers: { "Content-Type": "application/json", Accept: "application/json" },
        body: JSON.stringify({ items: [{ id: variantId, quantity: qty }] }),
      })
        .then(function (r) {
          if (!r.ok) return r.json().then(function (j) {
            throw new Error((j && (j.description || j.message)) || "Could not add");
          });
          return r.json();
        })
        .then(function () {
          return (discountCode ? applyDiscount(discountCode) : fetchCart()).then(function (cart) {
            if (!cart) return;
            if (discountCode) lastAppliedCode = discountCode;
            render(cart);
            updateCount(cart.item_count);
            if (!discountCode) syncTierDiscount(cart);
          });
        })
        .catch(function (err) {
          window.alert(err.message || "Could not add to cart");
        })
        .finally(function () {
          upsellAdding = false;
          btn.disabled = false;
        });
    });

    upsellsList.addEventListener("change", function (e) {
      if (!e.target.matches("[data-upsell-variant]")) return;
      var option = e.target.options[e.target.selectedIndex];
      var card = e.target.closest(".cart-drawer__upsell-card");
      card.querySelector("[data-upsell-add]").setAttribute("data-variant-id", option.value);
      card.querySelector(".cart-drawer__upsell-card-prices").innerHTML = upsellPriceHtml(
        parseInt(option.getAttribute("data-price"), 10) || 0,
        parseInt(option.getAttribute("data-compare"), 10) || 0
      );
    });
  }

  document.addEventListener("submit", function (e) {
    var form = e.target;
    if (!form || !form.matches || !form.matches('form[action*="/cart/add"]')) return;
    if (e.defaultPrevented) return;
    e.preventDefault();
    var _action = form.getAttribute("action") || "/cart/add";
    var _fd = new FormData(form);
    var bundle = form.querySelector('.bundle-deal-input:checked[data-bundle-accessory-variant]');
    if (bundle) {
      var accessoryId = Number(bundle.getAttribute("data-bundle-accessory-variant"));
      if (!Number.isSafeInteger(accessoryId) || accessoryId <= 0) {
        window.alert("The bundle gift is unavailable. Could not add this bundle to cart.");
        return;
      }
      var quantity = _fd.get("quantity") || "1";
      Array.from(_fd.entries()).forEach(function (entry) {
        if (/^(id|quantity|selling_plan|properties)(\[|$)/.test(entry[0])) {
          _fd.delete(entry[0]);
          _fd.append(entry[0].replace(/^([^\[]+)/, "items[0][$1]"), entry[1]);
        }
      });
      _fd.set("items[0][quantity]", quantity);
      _fd.set("items[1][id]", String(accessoryId));
      _fd.set("items[1][quantity]", quantity);
    }
    fetch(_action, {
      method: "POST",
      headers: { "Content-Type": "application/x-www-form-urlencoded" },
      body: new URLSearchParams(_fd),
      redirect: "manual",
    })
      .then(function (r) {
        if (r.type === "opaqueredirect") {
          CartDrawer.reloadAndOpen();
          return;
        }
        if (!r.ok) return r.text();
        return null;
      })
      .then(function (errBody) {
        if (errBody != null) {
          var msg = "Could not add to cart";
          try {
            var j = JSON.parse(errBody);
            msg = j.description || j.message || (j.errors && typeof j.errors === "string" ? j.errors : j.errors && j.errors[0]) || (j.error || msg);
          } catch (_) {
            var m = errBody.match(/<title>([^<]+)<\/title>/i);
            if (m) msg = m[1];
          }
          window.alert(msg);
        }
      })
      .catch(function () {
        window.alert("Could not add to cart");
      });
  });

  if (/[?&]cart=open\b/.test(location.search)) {
    fetchCart().then(function (cart) {
      render(cart);
      updateCount(cart.item_count);
      open();
    });
    var s = location.search.replace(/[?&]cart=open\b/, "").replace(/^&/, "?").replace(/[?&]$/, "");
    if (s === "?") s = "";
    var cleaned = location.pathname + s + location.hash;
    history.replaceState(null, "", cleaned);
  }
})();
